module.exports = __webpack_public_path__ + "public/img/3c_icon.fed767bc.png";